export const productPassportData = [{
    "type": "information",
    "template_version": "v2",
    "label": "PRODUCT DESCRIPTION",
    "title": "Black Long Sleeve Organza Poppy Mini Dress",
    "description": "* Boat neck \n* Long sleeves \n* Fitted bodice \n* Elasticated waist \n* Scoop back \n* Concealed zip fastening \n* Comfort stretch \n* Size tip: we recommend sizing up\n* Available in regular and petite. Under 5’3”? Find out more about petite sizing here",
    "size": "UK 18",
    "image_carousel": ["https://cdn.prod.xela.co/dpp/nbc/1256/6a73d2db61bd11d2a2b9a9c2ac1a.jpg", "https://cdn.prod.xela.co/dpp/nbc/d1a1/0bb68faa8c7012113c5e4f5166e4.jpg", "https://cdn.prod.xela.co/dpp/nbc/1b1c/78585be74185d775758d8e27f5a9.jpg", "https://cdn.prod.xela.co/dpp/nbc/2642/4bdf1678981cfa752f77e6ddaad0.jpg", "https://cdn.prod.xela.co/dpp/nbc/9758/2d7dddb424e8769d22d3e6d6d2fd.jpg"],
    "composition_main_fabric": "100% Recycled polyester; 67% LENZING™ ECOVERO™ Viscose, 29% Recycled polyester, 4% Elastane",
    "composition_linings": "",
    "info": [{
        "image": "https://assets.xela.co/nc/dpp/01f16d4a-f8ec-487e-9885-b1f039332253.jpg",
        "url_name": "Dresses",
        "url_path": "https://www.nobodyschild.com/collections/dresses"
    }, {
        "image": "https://assets.xela.co/nc/dpp/9de8aa1c-4f95-4490-a7eb-ca586485d2c8.jpg",
        "url_name": "Occasions",
        "url_path": "https://www.nobodyschild.com/collections/occasionwear"
    }, {
        "image": "https://assets.xela.co/nc/dpp/d863bcb7-d669-42b6-bb72-d16d313ad27e.jpg",
        "url_name": "Tops",
        "url_path": "https://www.nobodyschild.com/collections/tops"
    }]
}, {
    "style": "style_1",
    "type": "collapsable",
    "title": "Trace my steps",
    "collapsed": true,
    "description": "Thank you for being part of our journey towards greater transparency, as we aim to deepen your connection with the items you choose. We've engaged with our suppliers to explore every aspect of how this product is made, including its journey to our distribution centre in the UK. This is just the beginning of our commitment to transparency.",
    "product_journey": [{
        "name": "dpp_co_comp0_composition0",
        "title": "MAIN FABRIC (KNITTED): 100% Recycled polyester",
        "map": {},
        "steps": [{
            "title": "Warehouse",
            "display": "false",
            "image": "https://assets.xela.co/nc/dpp/13a01f53-4578-4df0-a24d-9aa84c43923c.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Warehousing refers to storage and inventory management of our styles, connecting production with distribution.",
                "width": "full"
            }, {"key": "Factory", "label": "NC_UK_DC"}, {"key": "Country", "label": "GB"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": ""}, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Trading Office",
            "image": "https://assets.xela.co/nc/dpp/7483c05e-4197-453f-b62a-69e512b7f01e.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is our supplier partner's HQ, managing the purchasing and production processes.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_00"}, {"key": "Country", "label": "VN"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": "BOAT;TRUCK"}, {
                "key": "Distance To Next Stage",
                "label": "18273",
                "unit": "km"
            }]
        }, {
            "title": "Manufacturing",
            "image": "https://assets.xela.co/nc/dpp/b66efa8f-7917-4ae2-8503-5129e0d6c25f.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "During manufacturing, materials are cut, sewn and finished to create each style. Ahead of shipping, our suppliers perform a quality check, then the style is shipped to our distribution centre.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_VIET_CUONG_MANUFACTURING"}, {
                "key": "Country",
                "label": "VN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "12", "unit": "km"}]
        }, {
            "title": "Dye House",
            "image": "https://assets.xela.co/nc/dpp/51f39aca-cb6e-4da9-84d8-dbc4f898c4a1.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, our designers' vision is brought to life as the material is dyed or printed, before being thoroughly washed to set the colour and pattern.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG LEGO INDUSTRIAL CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "3804", "unit": "km"}]
        }, {
            "title": "Knitting",
            "image": "https://assets.xela.co/nc/dpp/099e9a54-a9e9-480b-8c14-8c2953f75c2a.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, yarns are knitted into fabrics.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG RONGLAI TEXTILE CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "478", "unit": "km"}]
        }, {
            "title": "Yarn Mill",
            "image": "https://assets.xela.co/nc/dpp/497d5123-6ffc-43b5-88d5-821d68deb0b8.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, fibres are transformed into yarns through a process called spinning.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Recycling",
            "image": "https://assets.xela.co/nc/dpp/ffbe003f-d6e3-42cb-a44b-ea289e95d568.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is where existing materials are recycled into new raw materials. This is done through mechanical or chemical recycling.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }]
    }, {
        "name": "dpp_co_comp1_composition0",
        "title": "MAIN FABRIC (KNITTED): 67% LENZING™ ECOVERO™ Viscose",
        "map": {},
        "steps": [{
            "title": "Warehouse",
            "display": "false",
            "image": "https://assets.xela.co/nc/dpp/13a01f53-4578-4df0-a24d-9aa84c43923c.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Warehousing refers to storage and inventory management of our styles, connecting production with distribution.",
                "width": "full"
            }, {"key": "Factory", "label": "NC_UK_DC"}, {"key": "Country", "label": "GB"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": ""}, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Trading Office",
            "image": "https://assets.xela.co/nc/dpp/7483c05e-4197-453f-b62a-69e512b7f01e.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is our supplier partner's HQ, managing the purchasing and production processes.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_00"}, {"key": "Country", "label": "VN"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": "BOAT;TRUCK"}, {
                "key": "Distance To Next Stage",
                "label": "18273",
                "unit": "km"
            }]
        }, {
            "title": "Manufacturing",
            "image": "https://assets.xela.co/nc/dpp/b66efa8f-7917-4ae2-8503-5129e0d6c25f.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "During manufacturing, materials are cut, sewn and finished to create each style. Ahead of shipping, our suppliers perform a quality check, then the style is shipped to our distribution centre.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_VIET_CUONG_MANUFACTURING"}, {
                "key": "Country",
                "label": "VN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "12", "unit": "km"}]
        }, {
            "title": "Dye House",
            "image": "https://assets.xela.co/nc/dpp/51f39aca-cb6e-4da9-84d8-dbc4f898c4a1.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, our designers' vision is brought to life as the material is dyed or printed, before being thoroughly washed to set the colour and pattern.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG LEGO INDUSTRIAL CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "3804", "unit": "km"}]
        }, {
            "title": "Knitting",
            "image": "https://assets.xela.co/nc/dpp/099e9a54-a9e9-480b-8c14-8c2953f75c2a.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, yarns are knitted into fabrics.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG RONGLAI TEXTILE CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "478", "unit": "km"}]
        }, {
            "title": "Yarn Mill",
            "image": "https://assets.xela.co/nc/dpp/497d5123-6ffc-43b5-88d5-821d68deb0b8.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, fibres are transformed into yarns through a process called spinning.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Raw Material Processing",
            "image": "https://assets.xela.co/nc/dpp/f38e119a-f6a5-478b-a52d-b84350b97376.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, the fibre is processed and prepared for yarn production.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Raw Material",
            "image": "https://assets.xela.co/nc/dpp/f38e119a-f6a5-478b-a52d-b84350b97376.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "The supply chain starts here, with raw materials sourced for our products.",
                "width": "full"
            }, {"key": "Factory", "label": ""}, {"key": "Country", "label": "CN"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": "TRUCK"}, {
                "key": "Distance To Next Stage",
                "label": "500",
                "unit": "km"
            }]
        }]
    }, {
        "name": "dpp_co_comp1_composition1",
        "title": "MAIN FABRIC (KNITTED): 4% Elastane",
        "map": {},
        "steps": [{
            "title": "Warehouse",
            "display": "false",
            "image": "https://assets.xela.co/nc/dpp/13a01f53-4578-4df0-a24d-9aa84c43923c.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Warehousing refers to storage and inventory management of our styles, connecting production with distribution.",
                "width": "full"
            }, {"key": "Factory", "label": "NC_UK_DC"}, {"key": "Country", "label": "GB"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": ""}, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Trading Office",
            "image": "https://assets.xela.co/nc/dpp/7483c05e-4197-453f-b62a-69e512b7f01e.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is our supplier partner's HQ, managing the purchasing and production processes.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_00"}, {"key": "Country", "label": "VN"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": "BOAT;TRUCK"}, {
                "key": "Distance To Next Stage",
                "label": "18273",
                "unit": "km"
            }]
        }, {
            "title": "Manufacturing",
            "image": "https://assets.xela.co/nc/dpp/b66efa8f-7917-4ae2-8503-5129e0d6c25f.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "During manufacturing, materials are cut, sewn and finished to create each style. Ahead of shipping, our suppliers perform a quality check, then the style is shipped to our distribution centre.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_VIET_CUONG_MANUFACTURING"}, {
                "key": "Country",
                "label": "VN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "12", "unit": "km"}]
        }, {
            "title": "Dye House",
            "image": "https://assets.xela.co/nc/dpp/51f39aca-cb6e-4da9-84d8-dbc4f898c4a1.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, our designers' vision is brought to life as the material is dyed or printed, before being thoroughly washed to set the colour and pattern.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG LEGO INDUSTRIAL CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "3804", "unit": "km"}]
        }, {
            "title": "Knitting",
            "image": "https://assets.xela.co/nc/dpp/099e9a54-a9e9-480b-8c14-8c2953f75c2a.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, yarns are knitted into fabrics.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG RONGLAI TEXTILE CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "478", "unit": "km"}]
        }, {
            "title": "Yarn Mill",
            "image": "https://assets.xela.co/nc/dpp/497d5123-6ffc-43b5-88d5-821d68deb0b8.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, fibres are transformed into yarns through a process called spinning.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Raw Material Processing",
            "image": "https://assets.xela.co/nc/dpp/f38e119a-f6a5-478b-a52d-b84350b97376.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, the fibre is processed and prepared for yarn production.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }]
    }, {
        "name": "dpp_co_comp1_composition2",
        "title": "MAIN FABRIC (KNITTED): 29% Recycled polyester",
        "map": {},
        "steps": [{
            "title": "Warehouse",
            "display": "false",
            "image": "https://assets.xela.co/nc/dpp/13a01f53-4578-4df0-a24d-9aa84c43923c.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Warehousing refers to storage and inventory management of our styles, connecting production with distribution.",
                "width": "full"
            }, {"key": "Factory", "label": "NC_UK_DC"}, {"key": "Country", "label": "GB"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": ""}, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Trading Office",
            "image": "https://assets.xela.co/nc/dpp/7483c05e-4197-453f-b62a-69e512b7f01e.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is our supplier partner's HQ, managing the purchasing and production processes.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_00"}, {"key": "Country", "label": "VN"}, {
                "key": "Number Of Workers",
                "label": ""
            }, {"key": "Transportation", "label": "BOAT;TRUCK"}, {
                "key": "Distance To Next Stage",
                "label": "18273",
                "unit": "km"
            }]
        }, {
            "title": "Manufacturing",
            "image": "https://assets.xela.co/nc/dpp/b66efa8f-7917-4ae2-8503-5129e0d6c25f.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "During manufacturing, materials are cut, sewn and finished to create each style. Ahead of shipping, our suppliers perform a quality check, then the style is shipped to our distribution centre.",
                "width": "full"
            }, {"key": "Factory", "label": "SPIRIT_VIET_CUONG_MANUFACTURING"}, {
                "key": "Country",
                "label": "VN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "12", "unit": "km"}]
        }, {
            "title": "Dye House",
            "image": "https://assets.xela.co/nc/dpp/51f39aca-cb6e-4da9-84d8-dbc4f898c4a1.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, our designers' vision is brought to life as the material is dyed or printed, before being thoroughly washed to set the colour and pattern.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG LEGO INDUSTRIAL CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "3804", "unit": "km"}]
        }, {
            "title": "Knitting",
            "image": "https://assets.xela.co/nc/dpp/099e9a54-a9e9-480b-8c14-8c2953f75c2a.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "At this stage, yarns are knitted into fabrics.",
                "width": "full"
            }, {"key": "Factory", "label": "ZHEJIANG RONGLAI TEXTILE CO.,LTD"}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "478", "unit": "km"}]
        }, {
            "title": "Yarn Mill",
            "image": "https://assets.xela.co/nc/dpp/497d5123-6ffc-43b5-88d5-821d68deb0b8.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "Here, fibres are transformed into yarns through a process called spinning.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }, {
            "title": "Recycling",
            "image": "https://assets.xela.co/nc/dpp/ffbe003f-d6e3-42cb-a44b-ea289e95d568.svg",
            "info": [{
                "key": "What happens at this stage?",
                "label": "This is where existing materials are recycled into new raw materials. This is done through mechanical or chemical recycling.",
                "width": "full"
            }, {"key": "Factory", "label": "Hangzhou Chunhui Textile Co., Ltd."}, {
                "key": "Country",
                "label": "CN"
            }, {"key": "Number Of Workers", "label": ""}, {
                "key": "Transportation",
                "label": "TRUCK"
            }, {"key": "Distance To Next Stage", "label": "0", "unit": "km"}]
        }]
    }]
}, {
    "style": "style_2",
    "type": "collapsable",
    "title": "My product footprint",
    "description": "",
    "collapsed": true,
    "info": [{
        "title": "Carbon",
        "description": "This metric focuses on climate impact. It measures the carbon footprint in carbon dioxide equivalent (CO₂e), which adds up all greenhouse gases into a single figure showing their total contribution to climate change.",
        "info_data": {"count": "6.69", "unit": "kg", "element": "CO²e"},
        "info_progress": [{
            "title": "Main Fabric",
            "colour": "#77B9FE",
            "description": "Assesses the impact of sourcing and processing the raw materials used in the product.",
            "progress": "84.16"
        }, {
            "title": "Use Phase",
            "colour": "#3A7EC4",
            "description": "Assesses the impact of the use phase, based on standardised assumptions. This includes energy consumption for washing and care.",
            "progress": "3.04"
        }, {
            "title": "Product Transport",
            "colour": "#14A583",
            "description": "Assesses the impact of the transportation of materials and products throughout the supply chain.",
            "progress": "2.21"
        }, {
            "title": "End Of Life",
            "colour": "#FAC128",
            "description": "Assesses the impact of product disposal, including recycling, landfilling, or incineration.",
            "progress": "6.5"
        }, {
            "title": "Distribution",
            "colour": "#C73836",
            "description": "Assesses the impact of retail operations, including the energy and water inputs of distribution centres and stores.",
            "progress": "0.73"
        }, {
            "title": "Manufacturing",
            "colour": "#E9792E",
            "description": "Evaluates impact of the assembly and production of final product in manufacturing facilities.",
            "progress": "3.36"
        }, {
            "title": "Dyeing",
            "colour": "#2EC4B6",
            "description": "Assesses the impact of dyeing processes used to colour materials or products.",
            "progress": "0.0"
        }, {
            "title": "Fading",
            "colour": "#D490E0",
            "description": "Assesses the impact of finishing processes of materials or products.",
            "progress": "0.0"
        }, {
            "title": "Product Knitting",
            "colour": "#E83E8C",
            "description": "Assesses the impact of knitting yarns into finished products.",
            "progress": "0.0"
        }, {"title": "Trading", "colour": "#7B5BA6", "description": "", "progress": "0"}, {
            "title": "Packaging",
            "colour": "#96DCF8",
            "description": "Assesses the impact related to the materials and processes used for packaging the product.",
            "progress": "0"
        }, {"title": "Warehouse", "colour": "#96DCF8", "description": "", "progress": "0"}],
        "info_content": {
            "title": "The Calculations",
            "description": "These results were calculated using Fairly Made and consider cradle-to-grave impacts from raw materials to end of use (including the use phase). Lifecycle impact has been calculated based on the French environmental cost methodology and are inclusive of any linings. These results have not been third-party verified.",
            "index_icon": "/static/images/product-passport/fairly-made-index-logo.svg"
        }
    }, {
        "title": "Water",
        "description": "This metric indicates water impact. It is calculated by measuring water consumption of materials and production and assessing how much pressure it puts on local water resources, depending on whether the region is water-rich or water-scarce.",
        "info_data": {"count": "0.97", "icon": "waterdrop", "unit": "m3 eq", "element": ""},
        "info_progress": [{
            "title": "Main Fabric",
            "colour": "#77B9FE",
            "description": "Assesses the impact of sourcing and processing the raw materials used in the product.",
            "progress": "95.94"
        }, {
            "title": "Use Phase",
            "colour": "#3A7EC4",
            "description": "Assesses the impact of the use phase, based on standardised assumptions. This includes energy consumption for washing and care.",
            "progress": "5.9"
        }, {
            "title": "Product Transport",
            "colour": "#14A583",
            "description": "Assesses the impact of the transportation of materials and products throughout the supply chain.",
            "progress": "0.21"
        }, {
            "title": "End Of Life",
            "colour": "#FAC128",
            "description": "Assesses the impact of product disposal, including recycling, landfilling, or incineration.",
            "progress": "0"
        }, {
            "title": "Distribution",
            "colour": "#C73836",
            "description": "Assesses the impact of retail operations, including the energy and water inputs of distribution centres and stores.",
            "progress": "0"
        }, {
            "title": "Manufacturing",
            "colour": "#E9792E",
            "description": "Evaluates impact of the assembly and production of final product in manufacturing facilities.",
            "progress": "-2.05"
        }, {
            "title": "Dyeing",
            "colour": "#2EC4B6",
            "description": "Assesses the impact of dyeing processes used to colour materials or products.",
            "progress": "0.0"
        }, {
            "title": "Fading",
            "colour": "#D490E0",
            "description": "Assesses the impact of finishing processes of materials or products.",
            "progress": "0.0"
        }, {
            "title": "Product Knitting",
            "colour": "#E83E8C",
            "description": "Assesses the impact of knitting yarns into finished products.",
            "progress": "0.0"
        }, {"title": "Trading", "colour": "#7B5BA6", "description": "", "progress": "0"}, {
            "title": "Packaging",
            "colour": "#96DCF8",
            "description": "Assesses the impact related to the materials and processes used for packaging the product.",
            "progress": "0"
        }, {"title": "Warehouse", "colour": "#96DCF8", "description": "", "progress": "0"}],
        "info_content": {
            "title": "The Calculations",
            "description": "These results were calculated using Fairly Made and consider cradle-to-grave impacts from raw materials to end of use (including the use phase). Lifecycle impact has been calculated based on the French environmental cost methodology and are inclusive of any linings. These results have not been third-party verified.",
            "index_icon": "/static/images/product-passport/fairly-made-index-logo.svg"
        }
    }, {
        "title": "Fossil Resource Fuel",
        "description": "This metric looks at fossil fuel consumption, measured in megajoules (MJ). It indicates the depletion of non-renewable energy sources such as oil, coal, and natural gas. Increasing use of renewable energy helps reduce fossil fuel consumption.",
        "info_data": {"count": "90.9", "icon": "waterdropy", "unit": "MJ", "element": ""},
        "info_progress": [{
            "title": "Main Fabric",
            "colour": "#77B9FE",
            "description": "Assesses the impact of sourcing and processing the raw materials used in the product.",
            "progress": "61.35"
        }, {
            "title": "Use Phase",
            "colour": "#3A7EC4",
            "description": "Assesses the impact of the use phase, based on standardised assumptions. This includes energy consumption for washing and care.",
            "progress": "33.31"
        }, {
            "title": "Product Transport",
            "colour": "#14A583",
            "description": "Assesses the impact of the transportation of materials and products throughout the supply chain.",
            "progress": "2.16"
        }, {
            "title": "End Of Life",
            "colour": "#FAC128",
            "description": "Assesses the impact of product disposal, including recycling, landfilling, or incineration.",
            "progress": "-0.29"
        }, {
            "title": "Distribution",
            "colour": "#C73836",
            "description": "Assesses the impact of retail operations, including the energy and water inputs of distribution centres and stores.",
            "progress": "0.8"
        }, {
            "title": "Manufacturing",
            "colour": "#E9792E",
            "description": "Evaluates impact of the assembly and production of final product in manufacturing facilities.",
            "progress": "2.67"
        }, {
            "title": "Dyeing",
            "colour": "#2EC4B6",
            "description": "Assesses the impact of dyeing processes used to colour materials or products.",
            "progress": "0.0"
        }, {
            "title": "Fading",
            "colour": "#D490E0",
            "description": "Assesses the impact of finishing processes of materials or products.",
            "progress": "0.0"
        }, {
            "title": "Product Knitting",
            "colour": "#E83E8C",
            "description": "Assesses the impact of knitting yarns into finished products.",
            "progress": "0.0"
        }, {
            "title": "Packaging",
            "colour": "#96DCF8",
            "description": "Assesses the impact related to the materials and processes used for packaging the product.",
            "progress": "0"
        }],
        "info_content": {
            "title": "The Calculations",
            "description": "These results were calculated using Fairly Made and consider cradle-to-grave impacts from raw materials to end of use (including the use phase). Lifecycle impact has been calculated based on the French environmental cost methodology and are inclusive of any linings. These results have not been third-party verified.",
            "index_icon": "/static/images/product-passport/fairly-made-index-logo.svg"
        }
    }, {
        "title": "Freshwater Eutrophication",
        "description": "This metric looks at nutrient emissions (like nitrogen and phosphorus) that can pollute rivers and lakes. These substances can be found in pesticides and fertilisers, so sourcing organic materials often reduces freshwater eutrophication.",
        "info_data": {"count": "1.3", "icon": "waterdrop", "unit": "g P eq", "element": ""},
        "info_progress": [{
            "title": "Main Fabric",
            "colour": "#77B9FE",
            "description": "Assesses the impact of sourcing and processing the raw materials used in the product.",
            "progress": "88.97"
        }, {
            "title": "Use Phase",
            "colour": "#3A7EC4",
            "description": "Assesses the impact of the use phase, based on standardised assumptions. This includes energy consumption for washing and care.",
            "progress": "3.08"
        }, {
            "title": "Product Transport",
            "colour": "#14A583",
            "description": "Assesses the impact of the transportation of materials and products throughout the supply chain.",
            "progress": "0.18"
        }, {
            "title": "End Of Life",
            "colour": "#FAC128",
            "description": "Assesses the impact of product disposal, including recycling, landfilling, or incineration.",
            "progress": "0.25"
        }, {
            "title": "Distribution",
            "colour": "#C73836",
            "description": "Assesses the impact of retail operations, including the energy and water inputs of distribution centres and stores.",
            "progress": "0"
        }, {
            "title": "Manufacturing",
            "colour": "#E9792E",
            "description": "Evaluates impact of the assembly and production of final product in manufacturing facilities.",
            "progress": "7.52"
        }, {
            "title": "Dyeing",
            "colour": "#2EC4B6",
            "description": "Assesses the impact of dyeing processes used to colour materials or products.",
            "progress": "0.0"
        }, {
            "title": "Fading",
            "colour": "#D490E0",
            "description": "Assesses the impact of finishing processes of materials or products.",
            "progress": "0.0"
        }, {
            "title": "Product Knitting",
            "colour": "#E83E8C",
            "description": "Assesses the impact of knitting yarns into finished products.",
            "progress": "0.0"
        }, {"title": "Trading", "colour": "#7B5BA6", "description": "", "progress": "0"}, {
            "title": "Packaging",
            "colour": "#96DCF8",
            "description": "Assesses the impact related to the materials and processes used for packaging the product.",
            "progress": "0"
        }, {"title": "Warehouse", "colour": "#96DCF8", "description": "", "progress": "0"}],
        "info_content": {
            "title": "The Calculations",
            "description": "These results were calculated using Fairly Made and consider cradle-to-grave impacts from raw materials to end of use (including the use phase). Lifecycle impact has been calculated based on the French environmental cost methodology and are inclusive of any linings. These results have not been third-party verified.",
            "index_icon": "/static/images/product-passport/fairly-made-index-logo.svg"
        }
    }]
}, {
    "style": "style_3",
    "type": "collapsable",
    "title": "Durability",
    "description": "We test our clothing's physical durability using accredited laboratories. This ensures that your favourite styles maintain their shape and colour, allowing you to enjoy them for longer.",
    "collapsed": true,
    "info": [{
        "style": "durability_gauge",
        "count": "",
        "scale": 2,
        "info_data": [{
            "title": "Colour Fastness to Light",
            "scale_value": "",
            "description": "The resistance of a material's colour to fading when exposed to ultraviolet light.",
            "scale_steps": 5
        }, {
            "title": "Colour Fastness to Water",
            "scale_value": "",
            "description": "The resistance of a material's colour to fading when exposed to water.",
            "scale_steps": 5
        }, {
            "title": "Colour Fastness to Seawater",
            "scale_value": "",
            "description": "The resistance of a material's colour to fading when exposed to seawater.",
            "scale_steps": 5
        }, {
            "title": "Colour Fastness Wet Rub",
            "scale_value": "",
            "description": "The resistance of a material's colour transfer when subjected to rubbing or friction while wet.",
            "scale_steps": 5
        }, {
            "title": "Colour Fastness Dry Rub",
            "scale_value": "",
            "description": "The resistance of a material's colour transfer when subjected to rubbing or friction while dry.",
            "scale_steps": 5
        }, {
            "title": "Pilling",
            "scale_value": "",
            "description": "The material's tendency to form small balls of fibre on its surface due to friction and wear.",
            "scale_steps": 5
        }, {
            "title": "Shrinkage",
            "description": "The material's tendency to reduce in size after it has been subjected to washing, drying, or other processes.",
            "progress": ""
        }, {
            "title": "WIDTH / WEFT Shrinkage",
            "description": "The material’s tendency to reduce in size after it has been exposed to washing, drying, or other processes",
            "progress": ""
        }, {
            "title": "LENGTH / WARP Shrinkage",
            "description": "The material’s tendency to reduce in size after it has been exposed to washing, drying, or other processes",
            "progress": ""
        }]
    }]
}, {
    "style": "style_4",
    "type": "collapsable",
    "label": "Certifications",
    "title": "Certifications",
    "collapsed": true,
    "info": []
}, {
    "style": "style_5",
    "type": "collapsable",
    "title": "Packaging",
    "collapsed": true,
    "info": [{
        "count": "100%",
        "image": "https://assets.xela.co/nc/dpp/9546aa37-f16f-4448-9ed1-35a05817cd4f.png",
        "title": "Recycled & Recyclable",
        "description": "The tags on our products are crafted from paper that's 100% certified and sourced from forests that are managed responsibly. Additionally, the plastic bags used for our products are made entirely from recycled plastic and can be recycled again."
    }]
}, {
    "style": "style_6",
    "type": "collapsable",
    "title": "Care Instructions",
    "description": "Wash with similar colours/iron on reverse side. Wash inside out. Iron whilst damp. Dry clean responsibly. Do not rub isolated stains",
    "collapsed": true,
    "info": [{
        "style": "care_type",
        "care_symbols": ["30c_with_two_bars", "do_not_bleach", "do_not_tumble_dry", "iron_with_one_dot", "f_in_circle"]
    }, {
        "title": "Wash less",
        "icon": "https://assets.xela.co/nc/dpp/4374ca42-209b-4ea1-a47c-e7c05352d3ee.svg",
        "info": "Clothes worn next to the skin do not usually need washing after one wear."
    }, {
        "title": "Fill to the max",
        "icon": "https://assets.xela.co/nc/dpp/dc31a73c-b31d-43ca-8a06-2874544b6b6d.svg",
        "info": "Half loads of laundry use almost as much energy and detergent as the full thing."
    }, {
        "title": "Keep things cool",
        "icon": "https://assets.xela.co/nc/dpp/c4ec81e4-7413-4120-9584-5e20ae2fccf2.svg",
        "info": "Always take note of your care label, but doing your laundry at 30° is kinder to the planet."
    }, {
        "title": "Line dry",
        "icon": "https://assets.xela.co/nc/dpp/74d925fe-8482-474b-b40b-b882d101489f.svg",
        "info": "Line drying your clothes helps keep them in good shape for longer, reduces the need for ironing and saves on energy."
    }]
}, {
    "style": "style_7",
    "type": "collapsable",
    "title": "My finer details",
    "collapsed": true,
    "info": [{}, {
        "image": "https://assets.xela.co/nc/dpp/2f00f75f-7c7e-4b9d-b241-791494bf899f.svg",
        "image_format": "svg",
        "label": "XelaKey",
        "value": "nbc"
    }, {
        "image": "https://assets.xela.co/nc/dpp/0f7efc08-1aae-4f3d-8501-282528f45384.svg",
        "label": "GS1 Digital Link",
        "value": "dl.xela.id/01/05056825413483",
        "url": "https://dl.xela.id/01/05056825413483"
    }, {
        "image": "https://assets.xela.co/nc/dpp/92da747c-f6d0-4f8d-b04b-cb3f9a5b4449.svg",
        "label": "Style number",
        "value": "D254781BLK"
    }, {
        "image": "https://assets.xela.co/nc/dpp/fcba18c2-a79f-4c2e-b8d7-5f2348243335.svg",
        "label": "Fabric composition",
        "value": "100% Recycled polyester; 67% LENZING™ ECOVERO™ Viscose, 29% Recycled polyester, 4% Elastane"
    }, {
        "image": "https://assets.xela.co/nc/dpp/40720754-884b-41f5-bb4d-781b6f022c29.svg",
        "label": "Print",
        "value": ""
    }, {
        "image": "https://assets.xela.co/nc/dpp/a34dbaed-d4ab-4fa7-840b-7cfb3db72b21.svg",
        "label": "Live date",
        "value": "10/12/2025"
    }, {
        "image": "https://assets.xela.co/nc/dpp/12afbaca-3832-47fb-a7fd-889b59ab2970.svg",
        "label": "Size",
        "value": "18"
    }, {
        "image": "https://assets.xela.co/nc/dpp/b44fd8d7-f614-4895-b6f6-3902b60ce9d2.svg",
        "label": "Transport from factory",
        "value": "BOAT;TRUCK"
    }, {
        "image": "https://assets.xela.co/nc/dpp/088081c4-45ee-4e7e-aa6b-4fdb1747d2ba.svg",
        "label": "Country of origin",
        "value": "Vietnam"
    }, {
        "image": "https://assets.xela.co/nc/dpp/de93e2ac-ec0c-4041-a297-c8d770b333a8.svg",
        "label": "Main Fabric origin",
        "value": "CN"
    }, {
        "image": "https://assets.xela.co/nc/dpp/69f096be-412d-4bd9-b2da-a89f26e3f5e0.svg",
        "label": "Colour",
        "value": "Black"
    }, {
        "image": "https://assets.xela.co/nc/dpp/c1e02f25-d0ac-4988-be30-958d8756468b.svg",
        "label": "GTIN",
        "value": "5056825413483"
    }]
}, {
    "style": "style_8",
    "type": "collapsable",
    "title": "Repair & Reuse",
    "collapsed": true,
    "info": [{
        "title": "Rental Partners",
        "image": "https://assets.xela.co/nc/dpp/74a6e6ef-7c38-44a6-87a3-d2208491d324.png",
        "url_path": "https://www.nobodyschild.com/collections/nc-rental"
    }, {
        "title": "Garment \nTakeback Services",
        "image": "https://assets.xela.co/nc/dpp/e60b6fa0-1694-4b5f-9e9c-2ae5af165d8c.png",
        "url_path": "https://takeback.reskinned.clothing/nobodys-child"
    }, {
        "title": "Repairs & Alternation \nServices",
        "image": "https://assets.xela.co/nc/dpp/70ec7e43-67f7-4179-acac-dde8bcf65bcf.png",
        "url_path": "https://nobodyschild.sojo.uk/"
    }, {
        "title": "Pre-loved Partners",
        "image": "https://assets.xela.co/nc/dpp/fb813f33-f597-410b-addd-01f963723984.png",
        "url_path": "https://www.ebay.co.uk/e/fashion/nobodys-child-reskinned"
    }]
}];